import { Grid } from '@material-ui/core';
import {
  EntityLayout,
  EntityAboutCard,
  EntityLinksCard,
  EntitySwitch,
  isKind,
} from '@backstage/plugin-catalog';
import {
  EntityApiDefinitionCard,
} from '@backstage/plugin-api-docs';
import {
  EntityCloudbuildContent,
  isCloudbuildAvailable,
} from '@backstage/plugin-cloudbuild';
import {
  EntityGithubActionsContent,
  isGithubActionsAvailable,
} from '@backstage/plugin-github-actions';
import {
  EntityKubernetesContent,
  isKubernetesAvailable,
} from '@backstage/plugin-kubernetes';
import {
  EntityTechdocsContent,
} from '@backstage/plugin-techdocs';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';

const overviewContent = (
  <Grid container spacing={3} alignItems="stretch">
    <Grid item md={6}>
      <EntityAboutCard />
    </Grid>
    <Grid item md={6} xs={12}>
      <EntityCatalogGraphCard height={400} />
    </Grid>
    <Grid item md={6} xs={12}>
      <EntityLinksCard />
    </Grid>
    <EntitySwitch>
      <EntitySwitch.Case if={isKind('api')}>
        <Grid item md={12}>
          <EntityApiDefinitionCard />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>
  </Grid>
);
export const entityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('resource')}>
      <EntityLayout>
        <EntityLayout.Route path="/" title="Overview">
          {overviewContent}
        </EntityLayout.Route>
        <EntityLayout.Route path="/relations" title="Relations">
          <Grid container spacing={3} alignItems="stretch">
            <Grid item xs={12}>
              <EntityCatalogGraphCard height={600} />
            </Grid>
          </Grid>
        </EntityLayout.Route>
      </EntityLayout>
    </EntitySwitch.Case>

    <EntitySwitch.Case>
...
      <EntityLayout>
        <EntityLayout.Route path="/" title="Overview">
          {overviewContent}
        </EntityLayout.Route>

        <EntityLayout.Route path="/docs" title="Docs">
          <EntityTechdocsContent />
        </EntityLayout.Route>

        <EntityLayout.Route
          path="/ci-cd"
          title="CI/CD"
          if={isCloudbuildAvailable}
        >
          <EntityCloudbuildContent />
        </EntityLayout.Route>

        <EntityLayout.Route
          path="/ci-cd"
          title="CI/CD"
          if={isGithubActionsAvailable}
        >
          <EntityGithubActionsContent />
        </EntityLayout.Route>

        <EntityLayout.Route
          path="/kubernetes"
          title="Kubernetes"
          if={isKubernetesAvailable}
        >
          <EntityKubernetesContent />
        </EntityLayout.Route>
      </EntityLayout>
    </EntitySwitch.Case>
  </EntitySwitch>
);

export const EntityPage = () => entityPage;
